import { render } from "./CreateQuestionDialog.vue?vue&type=template&id=35a7f6a8&ts=true"
import script from "./CreateQuestionDialog.vue?vue&type=script&lang=ts"
export * from "./CreateQuestionDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__